
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/adjusting/send/detail/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline" :label-width="formLabelWidth">
          <!-- 搜索框插槽 -->
          <el-form-item :label="$t('craft_adjusting_record_adjusting_code')">
            {{row.adjustingCode}}
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            {{row.equipment.name}}
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            {{row.mould ?row.mould.name:"-"}}
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('shuaxin') }}
            </el-button>
          </el-form-item>
        </el-form>
      </template>
      <template #canshu="scope">
       <span>{{$t(scope.row.pointCodeI18n)}} </span>
        <span v-if="scope.row.pointCodeUnit"> / {{scope.row.pointCodeUnit}}</span>
      </template>
      <template #xiugaiqian="scope">
        <span style="display: none;"> {{tempPoint = points[scope.row.pointCode]}}</span>
        <span v-if="tempPoint.dictTypeCode">
          {{$t(store.state.dictJsonAll[tempPoint.dictTypeCode][scope.row.beforeValueToUnit])}}
        </span>
       <span v-else>{{scope.row.beforeValueToUnit}} </span>
      </template>
      <template #xiugaihou="scope">
        <span style="display: none;"> {{tempPoint = points[scope.row.pointCode]}}</span>
        <span v-if="tempPoint.dictTypeCode">
          {{$t(store.state.dictJsonAll[tempPoint.dictTypeCode][scope.row.afterValueToUnit])}}
        </span>
       <span v-else>{{scope.row.afterValueToUnit}} </span>
      </template>
    </yi_curd_table>

  </div>
</template>

<script>

export default {
  name: 'web_process_distribution_adjusting_record_send_detail_list',
  components: {

  },
  data() {
    return {
      points:null,
      columns: [
        {
          label: 'zhuangtai',
          prop: 'status',
          type: 'dictionary_tag',
          key: 'CRAFT_ADJUSTING_SEND_DETAIL_STATUS'

        },
        {
          label: 'canshu',
        /*  prop: 'pointCode',*/
          type:'slot'
        },
        {
          label: 'xiugaiqian',
        /*  prop: 'pointCode',*/
          type:'slot'
        },
        {
          label: 'xiugaihou',
          type:'slot',
        }
      ],

    };
  },
  props: {
    row: {
      type: [Object],
      required: true
    },
    formLabelWidth: {
      type: [String]
    },
  },

  created() {
    this.points =  this.store.state.eqPoints[this.row.equipmentId];
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime',
        adjustingId: this.row.id,

      };
      this.yt.get(1);
    }, 50);
  },
  methods: {


  }
};
</script>


<style scoped="scoped" lang="scss">
  ._form /deep/ .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    // height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100px;
  }

  ._formItem /deep/ .el-input__inner {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    // height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 80px;
  }

  ._form /deep/ .el-input__icon {
    content: '';
    height: 100%;
    width: 0;
    display: inline-block;
    vertical-align: middle;
    margin-left: -220px;
  }

  ._form /deep/ .el-select {
    min-width: 80px;

    .el-select-dropdown {
      .el-scrollbar {
        .el-select-dropdown__wrap {
          .el-scrollbar__view {
            .el-select-dropdown__item:hover {
            }
          }
        }
      }
    }
  }
</style>
